// Phone-only push/pop for a drill-in, like an iOS table: My Game into an area,
// and Profile into belt history. The wordmark and tab bar stay put; only the
// page content slides. Desktop and reduced-motion keep the instant navigation.

const DRILL_MS = 340

let drilledVisit = false
let pending = null

document.addEventListener("turbo:visit", () => {
  drilledVisit = false
})

document.addEventListener("turbo:before-cache", () => {
  document.querySelector("main")?.classList.remove("game-drill-enter-forward", "game-drill-enter-back")
})

document.addEventListener("turbo:before-render", (event) => {
  if (drilledVisit) {
    if (pending) {
      event.preventDefault()
      afterCurrentDrill().then(() => event.detail.resume())
    }
    return
  }

  const direction = drillDirection(event.detail.newBody)
  if (!direction || !event.detail.render) return

  drilledVisit = true

  if (typeof document.startViewTransition !== "function") {
    noteDrill(direction)
    enterWithClass(event.detail.newBody, direction)
    return
  }

  const render = event.detail.render
  event.detail.render = (currentElement, newElement) => {
    noteDrill(direction)
    document.documentElement.dataset.gameDrill = direction
    const finish = () => {
      delete document.documentElement.dataset.gameDrill
      pending = null
    }
    try {
      const transition = document.startViewTransition(() => render(currentElement, newElement))
      pending = transition.finished.finally(finish)
    } catch (_error) {
      finish()
      render(currentElement, newElement)
    }
  }
})

function drillDirection(newBody) {
  if (!window.matchMedia("(max-width: 767px)").matches) return null
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null
  if (document.documentElement.dataset.turboVisitDirection === "none") return null

  const from = drillScreen(document.body)
  const to = drillScreen(newBody)
  if (!from || !to || from.group !== to.group || from.depth === to.depth) return null
  return to.depth > from.depth ? "forward" : "back"
}

function drillScreen(body) {
  if (!body || !body.classList) return null
  const classes = body.classList
  if (classes.contains("training_areas")) {
    if (classes.contains("show")) return { group: "game", depth: 1 }
    if (classes.contains("index")) return { group: "game", depth: 0 }
  }
  if (classes.contains("students") && classes.contains("account")) return { group: "profile", depth: 0 }
  if (classes.contains("promotions") && classes.contains("index")) return { group: "profile", depth: 1 }
  return null
}

function enterWithClass(newBody, direction) {
  const main = newBody.querySelector && newBody.querySelector("main")
  if (!main) return
  main.classList.add(direction === "forward" ? "game-drill-enter-forward" : "game-drill-enter-back")
  pending = new Promise((resolve) => window.setTimeout(resolve, DRILL_MS)).finally(() => {
    pending = null
  })
}

function noteDrill(direction) {
  if (Array.isArray(window.rafaGameDrills)) window.rafaGameDrills.push(direction)
}

function afterCurrentDrill() {
  const drill = pending || Promise.resolve()
  const timeout = new Promise((resolve) => window.setTimeout(resolve, DRILL_MS + 80))
  return Promise.race([drill, timeout])
}
